module.exports = __webpack_public_path__ + "img/hc-logo-1.60fda415.jpg";